import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';

const GoodsDtlsTab = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="py-2">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Commodity</th>
                                    <th>Packages</th>
                                    <th>Gross Wt</th>
                                    <th>Net Wt</th>
                                    <th>Volume</th>
                                    <th>Charge Wt</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                    New
                </button>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Delete
                </button>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="button">
                Close
            </button>
        </div>
    </form>

    <Offcanvas show={showAdd} onHide={handleCloseAdd} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Good Dtls(New)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <textarea className="form-control form-control-sm" rows="2"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Packages</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Commodity</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Inner Pkgs</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Commodity Type</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                        <input type="text" className="form-control form-control-sm" value="Haz.Info" disabled />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Volume Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Dimension <sub>(l*b*h)</sub></label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />x
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />x
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />

                    </div>
                    <Select className="custom-selector w-100 mt-1" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Chargeable Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Volume</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Submit
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseAdd}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>

    <Offcanvas show={showEdit} onHide={handleCloseEdit} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Good Dtls(Edit)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <textarea className="form-control form-control-sm" rows="2"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Packages</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="form-label">Commodity</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Inner Pkgs</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Commodity Type</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                        <input type="text" className="form-control form-control-sm" value="Haz.Info" disabled />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Volume Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Dimension <sub>(l*b*h)</sub></label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />x
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />x
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />

                    </div>
                    <Select className="custom-selector w-100 mt-1" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Chargeable Wt</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Volume</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseEdit}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>
</>
);
};

export default GoodsDtlsTab;